import type { TaskCard } from '../lib/storage'
import { useLocale } from '../i18n/locale'
import { t } from '../i18n/strings'

export default function StatsBar({ tasks }: { tasks: TaskCard[] }) {
  const locale = useLocale()
  const tr = (k: string) => t(locale, k)
  const total = tasks.length
  const done = tasks.filter((t) => t.column === 'done').length
  const budget = tasks.reduce((s, t) => s + (t.estimatedCost || 0), 0)
  const spent = tasks.filter((t) => t.column === 'done').reduce((s, t) => s + (t.estimatedCost || 0), 0)
  const pct = budget > 0 ? Math.round((spent / budget) * 100) : 0

  const fmt = (n: number) =>
    n > 0 ? `$${n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` : '—'

  return (
    <div className="flex flex-wrap items-center gap-4 rounded-xl border border-border bg-surface px-5 py-3 text-sm">
      <div>
        <span className="text-text-subtle">{tr('stats.tasks')}</span>
        <span className="ml-2 font-semibold text-text">
          {done}/{total}
        </span>
      </div>

      <div>
        <span className="text-text-subtle">{tr('stats.budget')}</span>
        <span className="ml-2 font-semibold text-text">{fmt(budget)}</span>
      </div>

      <div>
        <span className="text-text-subtle">{tr('stats.spent')}</span>
        <span className="ml-2 font-semibold text-text">{fmt(spent)}</span>
      </div>

      {budget > 0 && (
        <div className="flex flex-1 items-center gap-2 min-w-[160px]">
          <div className="relative h-2 flex-1 overflow-hidden rounded-full bg-surface-2">
            <div
              className="absolute inset-y-0 left-0 rounded-full bg-brand transition-all"
              style={{ width: `${Math.min(100, pct)}%` }}
            />
          </div>
          <span className="text-xs text-text-subtle">{pct}%</span>
        </div>
      )}
    </div>
  )
}
